import { IconProps } from '@chakra-ui/react'
import OmensLogoType from 'components/svg/OmensLogoType'
import NextLink from 'next/link'
import * as React from 'react'
import { FC } from 'react'

const OmensLogoLink: FC<IconProps> = ({ color = '#000', ...props }) => (
  <NextLink href="/">
    <OmensLogoType {...{ color }} {...props} />
  </NextLink>
)

export default OmensLogoLink
